import gql from 'graphql-tag';

const storeSearchFields = gql`
  fragment storeSearchFields on StoreSearchResult {
    pagination {
      currentPage
      numberOfPages
      totalNumberOfResults
    }
    results {
      address {
        country {
          isocode
          name
        }
        line1
        line2
        region {
          isocodeShort
          name
        }
        postalCode
        town
        phone
      }
      additionalServices {
        code
      }
      code
      baseStore
      distance
      description
      displayName
      geoPoint {
        latitude
        longitude
      }
      legacyStoreCode
      rating {
        cleanlinessRating
        knowledgeRating
        rating
        numberOfReviews
      }
      pitPass
    }
    sourceLatitude
    sourceLongitude
    hasPitPassStore
  }
`;

export const GET_STORES_BY_SEARCH_TERM = gql`
  query searchStores(
    $includeInstallers: Boolean!
    $page: Int!
    $radius: Float
    $searchTerm: String
    $serviceCodes: [String]
    $additionalFilters: [AdditionalStoreFilter]
    $userStoreCode: String
  ) {
    store {
      search(
        includeInstallers: $includeInstallers
        page: $page
        radius: $radius
        searchTerm: $searchTerm
        serviceCodes: $serviceCodes
        additionalFilters: $additionalFilters
        userStoreCode: $userStoreCode
      ) {
        ...storeSearchFields
      }
    }
  }

  ${storeSearchFields}
`;

export const GET_STORES_BY_CITY_STATE = gql`
  query searchStoresByCity(
    $userStoreCode: String
    $page: Int!
    $city: String!
    $state: String!
    $includeInstallers: Boolean!
  ) {
    store {
      searchByCity(
        userStoreCode: $userStoreCode
        page: $page
        city: $city
        state: $state
        includeInstallers: $includeInstallers
      ) {
        ...storeSearchFields
      }
    }
  }

  ${storeSearchFields}
`;

export const GET_STORES_BY_LAT_LONG = gql`
  query storesByLatLong(
    $includeInstallers: Boolean!
    $latitude: Float!
    $longitude: Float!
    $page: Int!
    $radius: Float
    $serviceCodes: [String]
    $additionalFilters: [AdditionalStoreFilter]
    $userStoreCode: String
  ) {
    store {
      listByLatLong(
        includeInstallers: $includeInstallers
        latitude: $latitude
        longitude: $longitude
        page: $page
        radius: $radius
        serviceCodes: $serviceCodes
        additionalFilters: $additionalFilters
        userStoreCode: $userStoreCode
      ) {
        ...storeSearchFields
      }
    }
  }

  ${storeSearchFields}
`;

export const GET_STATE_STORE_LIST = gql`
  query storeCountByLocation(
    $state: String
    $includeInstallers: Boolean!
  ) {
    store {
      countByLocation(state: $state, includeInstallers: $includeInstallers) {
        name
        storeCount
      }
    }
  }
`;
